import React from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { TextField, Box, Typography, Checkbox, FormControlLabel } from "@mui/material";
import enLocale from "date-fns/locale/en-AU";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { DatePicker } from "@mui/x-date-pickers";
import { setFieldValue } from "formik";
import { useState } from "react";
import { useRef } from "react";

const MoodyDatePicker = ({ children, form, field, color, backgroundColor, fullWidth, ...props }) => {
  const { name, value } = field;
  const { setFieldValue } = form;
  console.log(props.maxDate, "maxDate");
  const inputRef = useRef();

  const [isDisabled, setIsDisabled] = useState(false);

  const [dateValue, setDateValue] = React.useState();

  function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  function formatDate(date) {
    return [date.getFullYear(), padTo2Digits(date.getMonth() + 1), padTo2Digits(date.getDate())].join("-");
  }

  const handleChange = (newValue) => {
    let dateChanged = "";
    setDateValue(newValue);
    dateChanged = newValue;
    setFieldValue(name, formatDate(dateChanged));
  };

  return (
    <LocalizationProvider adapterLocale={enLocale} dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        disablePast={!props?.disablePast ? true : false}
        ref={inputRef}
        disabled={props.disabled || isDisabled}
        components={{ OpenPickerIcon: CalendarMonthIcon }}
        maxDate={props.maxDate}
        value={value}
        minDate={props.minDate}
        onChange={handleChange}
        name={name}
        InputProps={{ sx: { "& .MuiSvgIcon-root": { color: `${color}` } } }}
        renderInput={(params) => {
          return (
            <TextField
              type="date"
              {...params}
              fullWidth={fullWidth ? fullWidth : false}
              error={false}
              inputProps={{
                ...params.inputProps,
                placeholder: props.placeholder,
              }}
            />
          );
        }}
      >
        {children}
      </DesktopDatePicker>
    </LocalizationProvider>
  );
};

export default MoodyDatePicker;
